(function ($, Drupal) {
  Drupal.behaviors.webformLogic = {
    attach: function (context, settings) {
      // On form submit scroll to the form top messages
      $('.webform-button--submit').once().on("click", function() {
        $(document).once().ajaxComplete(function() {
          var webform = $('#webform-submission-women-of-the-month-form-ajax');

          if(webform.length) {
            var scrollValue = webform.offset().top - 400;
            $('html, body').animate({ scrollTop: scrollValue }, 500);
          }
        });
      });

      // On click button open form
      $('.lifestyle--WEBFORM').once().each(function () {
        $(this).find('.lifestyle__btn').once().click(function (e) {
          e.preventDefault();
          $(this).toggleClass('opened');
          $(this).parents('.lifestyle--WEBFORM').find('.webform-reference').slideToggle();
          if ($(this).hasClass('opened')) {
            // Fake scroll smooth to the top of element slider
            var webform = $('#webform-submission-women-of-the-month-form-ajax');
            var scrollValue = webform.offset().top;
            $('html, body').animate({ scrollTop: scrollValue }, 500);
          }
        });
      });
    }
  };
})(jQuery, Drupal);
